import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const test: ContentBlock<"test"> = {
  id: makeId("test-infectious-disease"),
  kind: "test",
  tags: ["testing", "her", "his", "both-partners", "pre-cycle", "practical"],
  title: "Infectious Disease Panel",
  subtitle: "HIV, Hepatitis B & C, syphilis — required before ART procedures",
  body: {
    testName: "HIV/STI/Infectious Disease Panel",
    category: "blood-marker",
    whatItMeasures:
      "Screens for HIV, Hepatitis B & C, syphilis, and other infections. Required by US FDA for donor ART (21 CFR 1271, which exempts partner-only cycles); required in France for all AMP partners by the Code de la santé publique; routinely ordered by most US clinics as good practice.",
    howItWorks:
      "Blood draw for both partners. Results must be current (clinic-dependent; typically within 6-12 months for partner ART, and 7-30 days for donor specimens per FDA rules).",
    quickFacts: [
      { kind: "sample", value: "Blood" },
      { kind: "time", value: "5 min draw per person" },
      { kind: "pain", value: "Needle pinch" },
      { kind: "prep", value: "Usually both partners" },
      { kind: "results", value: "3-7 business days" },
    ],
    turnaroundTime: "3-7 business days",
    costRange: { low: 50, high: 300 },
    atHome: false,
    clinicRequired: false,
    dataPoints: [],
  },
  sources: [
    {
      title:
        "21 CFR 1271 - Eligibility Determination for Donors of Human Cells, Tissues, and Cellular and Tissue-Based Products",
      authors: "US Food and Drug Administration",
      journal: "Code of Federal Regulations",
      year: 2024,
      url: "https://www.ecfr.gov/current/title-21/chapter-I/subchapter-L/part-1271",
      evidenceLevel: "expert-opinion",
    },
    {
      title:
        "Recommendations for gamete and embryo donation: a committee opinion",
      authors:
        "Practice Committee of the American Society for Reproductive Medicine and Practice Committee of the Society for Assisted Reproductive Technology",
      journal: "Fertility and Sterility",
      year: 2021,
      url: "https://www.asrm.org/practice-guidance/practice-committee-documents/recommendations-for-gamete-and-embryo-donation-a-committee-opinion-2021/",
      evidenceLevel: "guideline",
    },
  ],
  readTimeMinutes: 3,
};

registerBlock(test);
